function getFeature(status, feature) {
  const stages = {
    null: "stage0",
    declined: "stage0",
    pending: "stage1",
    processed: "stage2",
    "en route": "stage3",
    completed: "stage4",
    all: "stage5",
  };

  const features = {
    color: {
      stage0: "red",
      stage1: "#00AFB5",
      stage2: "#658cbb",
      stage3: "#DA627D",
      stage4: "green",
      stage5: "#FF7700",

      //       stage0: "red",
      //       stage1: "teal",
      //       stage2: "success",
      //       stage3: "info",
      //       stage4: "success",
    },
    value: {
      stage0: 0,
      stage1: 25,
      stage2: 50,
      stage3: 75,
      stage4: 100,
    },
    icon: {
      stage0: "mdi-alert-circle",
      stage1: "mdi-check",
      stage2: "mdi-thumb-up",
      stage3: "mdi-bike-fast",
      stage4: "mdi-check-all",
    },
  };

  return features[feature][stages[status]];
}

function getColor(status) {
  return getFeature(status, "color");
}

export { getColor, getFeature };
